import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import config from '../config/index';

const getToken = (): string | undefined => {
  return Cookies.get(config.auth.aTokenKey);
};

const getRefreshToken = (): string | undefined => {
  return Cookies.get(config.auth.arTokenKey);
};

const removeToken = () => {
  Cookies.remove(config.auth.aTokenKey);
};

const isLoggedIn = (): boolean => {
  const cookie = Cookies.get(config.auth.aTokenKey);

  return cookie !== '' && cookie !== undefined ? true : false;
};

const decodeToken = (): string => {
  const token = Cookies.get(config.auth.aTokenKey) as string;

  return jwtDecode(token);
};

export default {
  getToken,
  getRefreshToken,
  removeToken,
  isLoggedIn,
  decodeToken,
};
